import { useAppSelector } from '../../../redux/hooks.ts';
import { selectCompSequence } from '../../../redux/features/selectors/orderSelectors.ts';
import { selectSiteEntities } from '../../../redux/features/selectors/propertyDataSelectors/siteSelectors.ts';
import { selectSiteValues } from '../../../redux/features/selectors/selectSiteValue.ts';
import { getSiteSizeVsSiteValueGraphExportData } from './getSiteSizeVsSiteValueGraphExportData.ts';
import { SiteSizeVsSiteValueGraphChart } from './SiteSizeVsSiteValueGraphChart.tsx';
import { GraphProps } from '../types.ts';

export const SiteSizeVsSiteValueGraph = ({ disableAnimations, width, height }: GraphProps) => {
  const compSequence = useAppSelector(selectCompSequence);
  const siteEntities = useAppSelector(selectSiteEntities);
  const siteValues = useAppSelector(selectSiteValues);

  const data = getSiteSizeVsSiteValueGraphExportData(compSequence, siteEntities, siteValues);

  return (
    <SiteSizeVsSiteValueGraphChart
      data={data}
      disableAnimations={disableAnimations}
      width={width}
      height={height}
    />
  );
};
